// jQueryプラグインとしてMultiple Selectを使用
export function initMultiSelect(elem = document) {
    if(elem === undefined) {
        elem = document;
    }
    
    // CDNから読み込まれたjQueryを使用
    const $ = window.jQuery || window.$;
    
    if (!$) {
        console.error('jQuery is not loaded');
        return;
    }
    
    // multipleSelectライブラリが利用可能になるまで待機
    const waitForMultipleSelect = () => {
        if (typeof $.fn.multipleSelect !== 'undefined') {
            initializeMultiSelect(elem, $);
        } else {
            // 100ms後に再試行
            setTimeout(waitForMultipleSelect, 100);
        }
    };
    
    waitForMultipleSelect();
}

function initializeMultiSelect(elem, $) {
    $(elem).find("[data-provider='multi-select']").each(function () {
        const $element = $(this); // jQueryオブジェクトとして保存
        
        // 表示を調整
        $element.hide();
        
        let multiSelectData = {
            formatSelectAll: function() {
                return "すべて選択";
            },
            formatAllSelected: function() {
                return "すべて";
            },
            formatCountSelected: function(count, total) {
                return total + "件中" + count + "件選択";
            },
        };
        
        // カスタム属性から設定を読み込む
        if ($element.attr("data-multi-select-show-header")) {
            multiSelectData.showHeader = $element.attr("data-multi-select-show-header") === "true";
        }
        
        if ($element.attr("data-multi-select-none-selected-text")) {
            multiSelectData.noneSelectedText = $element.attr("data-multi-select-none-selected-text");
        }
        
        if ($element.attr("data-multi-select-fade-speed")) {
            multiSelectData.fadeSpeed = parseInt($element.attr("data-multi-select-fade-speed"));
        }
        
        if ($element.attr("data-multi-select-min-width")) {
            multiSelectData.minWidth = parseInt($element.attr("data-multi-select-min-width"));
        }
        
        if ($element.attr("data-multi-select-max-height")) {
            multiSelectData.maxHeight = parseInt($element.attr("data-multi-select-max-height"));
        }
        
        // 選択されたテキストのカスタム関数
        multiSelectData.selectedText = function(numChecked, numTotal, checkedItems) {
            return selectedTextTitle(numChecked, numTotal, checkedItems, 2);
        };
        
        // jQueryプラグインとしてMultiple Selectを初期化
        $element.multipleSelect(multiSelectData);

        // DOM準備完了後に表示
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function() {
                $element.show();
            });
        } else {
            $element.show();
        }
    });
}

// 選択されたテキストのタイトルを生成する関数
function selectedTextTitle(numChecked, numTotal, checkedItems, maxDisplay) {
    if (numChecked === 0) {
        return "すべて";
    }
    
    if (numChecked === numTotal) {
        return "すべて選択済み";
    }
    
    if (numChecked <= maxDisplay) {
        return checkedItems.map(item => item.text).join(', ');
    }
    
    return `${numChecked}項目選択済み`;
}
